module.exports = __webpack_public_path__ + "static/media/block-video.832fa3ff.svg";